module.exports = __webpack_public_path__ + "src/img/del.a02811d3.svg";